<template>
  <form>
    <input-select
      title="Тип"
      option-title-key="title"
      option-value-key="value"
      v-bind:options="itemTypes"
      v-model="selectedType"
    />
    <form-treatment-plan-template
      v-if="isSelectedTemplate"
      class="treatment-plan-templates-dialog__form"
      v-bind:treatments-categories="treatmentsCategories"
      v-bind:dental-services="clinicServiceCategories"
      v-bind:price-lists="clinicServicePriceLists"
      v-bind:service-units="serviceUnits"
      v-bind:input-errors="inputErrors"
      v-on:submit="onSubmitCreateTemplate"
      v-on:cancel="onCancel"
    />
    <form-treatment-plan-template-category-creation
      v-if="isSelectCategory"
      v-bind:input-errors="inputErrors"
      v-on:on-submit="onSubmitCreateCategory"
      v-on:cancel="onCancel"
    />
  </form>
</template>

<script>
import InputSelect from '@/components/InputSelect.vue';
import FormTreatmentPlanTemplate from '@/components/FormTreatmentPlanTemplate.vue';
import FormTreatmentPlanTemplateCategoryCreation from '@/components/FormTreatmentPlanTemplateCategoryCreation.vue';
import formTreatmentPlanTemplateItemMixin from '@/mixins/formTreatmentPlanTemplateItemMixin';

/**
 * @description Название события создания категории.
 * @type {string}
 */
const EVENT_NAME_CREATE_CATEGORY = 'on-create-category';

/**
 * @description Название событие создание шаблона.
 * @type {string}
 */
const EVENT_NAME_CREATE_TEMPLATE = 'on-create-template';

/**
 * @description Название событие отмены.
 * @type {string}
 */
const EVENT_NAME_CANCEL = 'cancel';

export default {
  name: 'FormTreatmentPlanTemplateItem',
  components: {
    FormTreatmentPlanTemplateCategoryCreation,
    FormTreatmentPlanTemplate,
    InputSelect,
  },
  computed: {
  },
  methods: {
    /**
     * @description Обработка события категории.
     *
     * @param {TemplatePlanRequest} request
     *
     * @returns {void}
     */
    onSubmitCreateCategory(request) {
      this.$emit(EVENT_NAME_CREATE_CATEGORY, request);
    },
    /**
     * @description Обработка события шаблона.
     *
     * @param {TemplatePlanRequest} request
     *
     * @returns {void}
     */
    onSubmitCreateTemplate(request) {
      this.$emit(EVENT_NAME_CREATE_TEMPLATE, request);
    },
    /**
     * @description Обработка события отмены.
     * @
     */
    onCancel() {
      this.$emit(EVENT_NAME_CANCEL);
    },
  },
  props: {
    /**
     * @description Категории планов шаблона лечения.
     * @type Array
     */
    treatmentsCategories: {
      type: Array,
      required: true,
    },
    /**
     * @description Стоматологические услуги.
     * @type {{code: string, name: string}[]}
     */
    clinicServiceCategories: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Прайс листы клиники.
     * @type {any[]}
     */
    clinicServicePriceLists: {
      required: true,
      type: Array,
    },
    /**
     * @description Единицы измерения.
     * @type {any[]}
     */
    serviceUnits: {
      required: true,
      type: Array,
    },
    /**
     * @description Ошибки ввода.
     * @returns {Array}
     */
    inputErrors: { type: Object, required: true },
  },
  mixins: [
    formTreatmentPlanTemplateItemMixin,
  ],
  serviceTaxCodeOptions: [
  ],
};
</script>

<style scoped lang="scss">

</style>
